import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        slidesPerView: 1.8,
        spaceBetween: 16,
        rewind: true,
        watchOverflow: true,
        speed: 1000,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.8,
            spaceBetween: 16,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
      });
    }
  });
}
